module.exports = __webpack_public_path__ + "static/media/whatsapp-icon.54c87fbb.svg";